import React from 'react';
import styled from 'styled-components';
import {
    purple70,
    blue100,
    purple10,
} from '@zocdoc-mezzanine/foundations-colors';

/**
 * A Banner
 * @param {JsxElement} textContent - Text content to render.
 *  This can contain **<a>**, **<b>** tags, and anything else you want to render.
 */
export const Banner = (props) => {
    return (
        <Bar>
            <LeftBorder />
            <TextContent>{props.textContent}</TextContent>
        </Bar>
    );
};

const Bar = styled.div`
    display: flex;
    box-sizing: border-box;
    width: 100%;
`;

const LeftBorder = styled.div`
    width: 8px;
    border-left: solid 1px ${purple70};
    background-color: ${purple70};
    border-radius: 2px 0px 0px 2px;
`;

const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    overflow-wrap: break-word;
    font-family: 'Sharp Sans';
    font-size: 15px;
    line-height: 22px;
    color: ${blue100};
    background-color: ${purple10};
    white-space: nowrap;
`;
